<ng-container *finLet="tierProgressData$ | async as tierProgressData">
  <div
    class="flex flex--column border rounded-large overflow-hidden tier-card grow"
    *finLet="showLifetime$ | async as showLifetime"
  >
    <div class="grow relative">
      <div class="grow flex flex--row">
        <div
          #progressContainer
          [class.slide-in]="!showLifetime"
          class="flex-1 slide slide-left ps-medium-x"
          data-testid="tier-progress"
        >
          <ng-container [ngTemplateOutlet]="tierProgress"></ng-container>
        </div>
        <div
          [class.slide-in]="showLifetime"
          [style.minHeight.px]="progressContainer.clientHeight"
          class="flex-1 slide slide-right ps-medium-x"
          data-testid="lifetime-progress"
        >
          <ng-container [ngTemplateOutlet]="lifetimeProgress"></ng-container>
        </div>
      </div>
    </div>

    <div class="ps-medium">
      <fcom-button
        *ngIf="showLifetime"
        (clickBtn)="showLifetime$.next(!showLifetime)"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [text]="'LOYALTY.tierProgress.showTierProgress' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.ARROW_LEFT, position: IconPosition.LEFT }"
        data-testid="show-tier-progress-button"
      >
      </fcom-button>
      <fcom-button
        *ngIf="!showLifetime"
        (clickBtn)="showLifetime$.next(!showLifetime)"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [text]="'LOYALTY.tierProgress.showLifetimeProgress' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
        data-testid="show-lifetime-progress-button"
      >
      </fcom-button>
    </div>

    <div
      class="flex flex--middle ps-medium-x ps-xsmall-y nordic-blue-25-bg rounded-bottom-large font-body-2 regular-type"
      *finLet="lifetimeProgressData$ | async as lifetimeProgressData"
    >
      <fcom-icon
        class="flex--shrink0 icon-small nordic-blue-900-text ms-xsmall-r"
        [name]="SvgLibraryIcon.INFO_BLOCK"
      ></fcom-icon>

      <div data-testid="footer-text">
        {{
          showLifetime && !!lifetimeProgressData.lifetimeTier
            ? ('LOYALTY.tierProgress.reachedLifetime' | finLocalization: { tier: lifetimeProgressData.lifetimeTier })
            : tierProgressData.isStartingTier
              ? ('LOYALTY.tierProgress.trackingEnd'
                | finLocalization
                  : {
                      tier: tierProgressData.tierName,
                      date: tierProgressData.trackingPeriodEnd | finDateFormat: 'DATE',
                    })
              : ''
        }}
      </div>
    </div>
  </div>
</ng-container>

<ng-template #tierProgress>
  <ng-container
    [ngTemplateOutlet]="cardHeader"
    [ngTemplateOutletContext]="{ title: 'plus.pointsBalance.tierProgress' | finLocalization }"
  ></ng-container>

  <ng-container *finLet="tierProgressData$ | async as tierProgressData">
    <div class="flex">
      <div class="tier-and-points-container dn-tablet-down flex flex--center align-center ps-medium-r">
        <ng-container [ngTemplateOutlet]="tierAndPoints"></ng-container>
      </div>

      <div
        *finLet="isMobile$ | async as isMobile"
        [ngClass]="{ 'flex--column': isMobile }"
        class="flex flex-1 regular-type"
      >
        <div class="dn-tablet-up align-center ms-medium-b">
          <ng-container [ngTemplateOutlet]="tierAndPoints"></ng-container>
        </div>

        <div [class.align-center]="isMobile">
          <span
            *ngIf="tierProgressData.tierProgress >= 10"
            class="font-body-1 inline-block nordic-blue-50-bg rounded bold-type ps-xxsmall-y ps-xsmall-x rounded-large ms-medium-b"
            data-testid="tier-progress-target"
          >
            <fcom-icon
              class="icon-medium nordic-blue-900-text ps-xxsmall-r"
              [name]="SvgLibraryIcon.AIRCRAFT_TILTED"
            ></fcom-icon>

            <span data-testid="tier-progress-percentage-text">
              <ng-container *ngIf="tierProgressData.tierState !== TierState.HIGHEST; else highestPercentageText">
                <span>{{ 100 - tierProgressData.tierProgress + '% ' }}</span>
                <span>{{
                  ((tierProgressData.tierState === TierState.GAIN
                    ? 'plus.pointsBalance.progressTo'
                    : 'plus.pointsBalance.progressToMaintain'
                  ) | finLocalization) + ' '
                }}</span>
                <span>{{ tierProgressData.targetTierName }}</span>
              </ng-container>

              <ng-template #highestPercentageText>
                {{
                  'LOYALTY.tierProgress.highestLumo'
                    | finLocalization
                      : { tierProgress: tierProgressData.tierProgress, tier: tierProgressData.targetTierName }
                }}
              </ng-template>
            </span>
          </span>

          <p
            *ngIf="tierProgressData.targetTier !== ProfileTier.LUMO"
            data-testid="tier-progress-gain-maintain-non-lumo-info"
          >
            {{
              (tierProgressData.tierState === TierState.GAIN
                ? 'LOYALTY.tierProgress.gainTier'
                : 'LOYALTY.tierProgress.maintainTier'
              ) | finLocalization: { tier: tierProgressData.targetTierName }
            }}
          </p>

          <p
            *ngIf="tierProgressData.targetTier === ProfileTier.LUMO"
            data-testid="tier-progress-gain-maintain-lumo-info"
          >
            {{
              (tierProgressData.tierState === TierState.GAIN
                ? 'LOYALTY.tierProgress.gainLumo'
                : 'LOYALTY.tierProgress.maintainLumo'
              )
                | finLocalization
                  : {
                      points: tierProgressData.targetTierLimit | finPoints,
                      finnairPoints: (tierProgressData.aySecretTierPointsRequired | finPoints),
                    }
            }}
          </p>

          <br />

          <p
            *ngIf="tierProgressData.isGainingMaintainingOrHighestLumo"
            data-testid="tier-progress-ay-tier-points-only-info"
          >
            {{ 'LOYALTY.tierProgress.pointsCollected' | finLocalization }}
            <span class="bold-type">
              {{ tierProgressData.aySecretTierPoints | finPoints }} /
              {{ tierProgressData.aySecretTierPointsRequired | finPoints }}
            </span>
          </p>

          <p>
            {{ 'LOYALTY.tierProgress.trackingPeriod' | finLocalization }}
            <span class="bold-type">
              {{ tierProgressData.trackingPeriodStart | finDateFormat: 'DATE' }}
              -
              {{ tierProgressData.trackingPeriodEnd | finDateFormat: 'DATE' }}
            </span>
          </p>
        </div>
      </div>
    </div>

    <ng-template #tierAndPoints>
      <div class="flex--column" aria-hidden="true">
        <span class="block nordic-blue-900-text font-heading-3 ps-xsmall-b">{{
          tierProgressData.tierPointsCollected | finPoints
        }}</span>
        <div class="nordic-blue-300-text font-body-1">
          <span class="regular-type">/ {{ tierProgressData.targetTierLimit | finPoints }}</span>
          <span class="block bold-type">{{ tierProgressData.targetTierName }}</span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #lifetimeProgress>
  <div *finLet="lifetimeProgressData$ | async as lifetimeProgressData">
    <ng-container
      [ngTemplateOutlet]="cardHeader"
      [ngTemplateOutletContext]="{
        title:
          ('LOYALTY.tierProgress.lifetimeTierProgress'
          | finLocalization: { tier: lifetimeProgressData.lifetimeTargetTier }),
      }"
    ></ng-container>

    <div class="ps-small-b" *finLet="isMobile$ | async as isMobile">
      <div class="dn-tablet-up align-center ms-xxlarge">
        <ng-container [ngTemplateOutlet]="targetPlusIcon"></ng-container>
      </div>
      <div class="flex flex--row ms-medium-y">
        <p [ngClass]="{ 'ms-xxlarge-r fill': !isMobile }" data-testid="lifetime-progress-paragraph">
          {{
            lifetimeProgressData.lifetimeTier === ProfileTier.PLATINUM
              ? ('LOYALTY.tierProgress.withLifetimePlatinum' | finLocalization)
              : ('LOYALTY.tierProgress.withLifeTime'
                | finLocalization: { tier: lifetimeProgressData.lifetimeTargetTier })
          }}
        </p>
        <div class="ms-medium-y ms-xxlarge-x dn-tablet-down">
          <ng-container [ngTemplateOutlet]="targetPlusIcon"></ng-container>
        </div>
      </div>

      <fcom-progress-indicator
        [progress]="lifetimeProgressData.qualifyingLifetimeTierPoints"
        [total]="lifetimeProgressData.lifetimeTargetTierLimit"
        [fillColor]="'nordic-blue-900-bg'"
        [ariaLabel]="
          'tierProgress.aria.lifetimeGain' | finLocalization: { tierLevel: lifetimeProgressData.lifetimeTargetTier }
        "
      >
        <div [attr.aria-label]="'tierProgress.lifetimeTierPoints' | finLocalization">
          <div>
            <span class="medium-type">{{ lifetimeProgressData.qualifyingLifetimeTierPoints | finPoints }}</span> /
            {{ lifetimeProgressData.lifetimeTargetTierLimit | finPoints }}
          </div>
        </div></fcom-progress-indicator
      >
    </div>

    <ng-template #targetPlusIcon>
      <fcom-icon
        aria-hidden="true"
        class="icon-xxlarge {{
          lifetimeProgressData.lifetimeTargetTier === ProfileTier.PLATINUM
            ? 'loyalty-platinum-light-text'
            : 'loyalty-gold-light-text'
        }}"
        [name]="SvgLibraryIcon.FINNAIR_EMBLEM_BLOCK"
      ></fcom-icon>
    </ng-template>
  </div>
</ng-template>

<ng-template #cardHeader let-title="title">
  <div *finLet="lifetimeProgressData$ | async as lifetimeProgressData" class="flex flex--wrap ps-medium-t ms-medium-b">
    <span class="flex-1 font-heading-5 nordic-blue-900-text">{{ title }}</span>
    <fcom-tag
      *ngIf="lifetimeProgressData.lifetimeTier"
      class="ms-xsmall-b"
      data-testid="card-header-lifetime-tier-chip"
      >{{ 'plus.pointsBalance.lifetimeTier' | finLocalization: { tier: lifetimeProgressData.lifetimeTier } }}</fcom-tag
    >
  </div>
</ng-template>
